export default __webpack_public_path__ + "static/media/AII_TRAN.3a376c7a.png";